import { render, staticRenderFns } from "./personalEdit.vue?vue&type=template&id=fbc69df4&"
import script from "./personalEdit.vue?vue&type=script&lang=js&"
export * from "./personalEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports